(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter/assets/javascripts/text/sum.js') >= 0) return;  svs.modules.push('/components/tur/payfooter/assets/javascripts/text/sum.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.payfooter = svs.tur.payfooter || {};
svs.tur.payfooter.text = svs.tur.payfooter.text || {};
class Sum extends svs.tur.payfooter.text.Default {
  constructor(_ref) {
    let {
      text = 'Summa',
      amount = 0
    } = _ref;
    super({
      text,
      listenOn: svs.tur.payfooter.SUM_UPDATED,
      amount
    });
    this.log = new svs.core.log.Logger('betslip:payfooter:text:sum');
    this.amountHandler.dimmed = true;
  }
  classNames() {
    return ['payfooter-text-sum'];
  }
}
svs.tur.payfooter.text.Sum = Sum;

 })(window);